import { Injectable } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AlertModalComponent } from '@app/shared/modals/alert-modal.component';
import { SafeHtml } from '@angular/platform-browser';
import { FairnessModalComponent } from '@app/shared/modals/fairness-modal.component';
import { TermsandconditionsModalComponent } from '@app/shared/modals/termsandconditions-modal.component';
import { FairnessResultModalComponent } from '@app/shared/modals/fairness-result-modal.component';
import { PrivacypolicyModalComponent } from '@app/shared/modals/privacypolicy-modal.component';
import { ModalChestForDepositComponent } from '@app/shared/modals/chest-for-deposit-modal.component';
import { ModalActiveBonusesComponent } from '@app/shared/modals/active-bonuses-modal.component';
import { DepositPromotionModalComponent } from '@app/shared/modals/deposit-promotion-modal.component';
import { SelfieCaptureModalComponent } from '@app/shared/modals/selfie-capture-modal.component';

@Injectable()
export class ModalService {
  public alertModalRef: NgbModalRef = null;
  public fairnessModalRef: NgbModalRef = null;
  public termsAndConditionsModalRef: NgbModalRef = null;
  public privacyPolicyModalRef: NgbModalRef = null;
  public fairnessResultModalRef: NgbModalRef = null;
  public chestForDepositModalRef: NgbModalRef = null;
  public activeBonusesModalRef: NgbModalRef = null;
  public depositPromotionModalRef: NgbModalRef = null;
  public selfieModalRef: NgbModalRef = null;

  constructor(private modalService: NgbModal) {}

  public openAlert(
    options: { title?: string; text?: string | SafeHtml; ok?: string; cancel?: string; hero?: string },
    multiple: boolean = true
  ): NgbModalRef {
    if (!multiple && this.alertModalRef !== null) {
      this.alertModalRef.close();
      this.alertModalRef = null;
    }
    this.alertModalRef = this.modalService.open(AlertModalComponent, {
      windowClass: 'general-modal',
    });
    this.alertModalRef.componentInstance.title = options.title || 'Note';
    this.alertModalRef.componentInstance.text = options.text || 'Something happened';
    this.alertModalRef.componentInstance.ok = options.ok || 'Ok';
    this.alertModalRef.componentInstance.cancel = options.cancel || null;
    this.alertModalRef.componentInstance.hero = options.hero || null;
    this.alertModalRef.componentInstance._service = this;
    return this.alertModalRef;
  }

  public openSelfie(): NgbModalRef {
    this.selfieModalRef = this.modalService.open(SelfieCaptureModalComponent, {
      windowClass: 'camera-capture-modal',
    });
    // this.alertModalRef.componentInstance.title = options.title || 'Note';
    // this.alertModalRef.componentInstance.text = options.text || 'Something happened';
    // this.alertModalRef.componentInstance.ok = options.ok || 'Ok';
    // this.alertModalRef.componentInstance.cancel = options.cancel || null;
    // this.alertModalRef.componentInstance.hero = options.hero || null;
    // this.alertModalRef.componentInstance._service = this;
    return this.selfieModalRef;
  }

  public openSignatureAlert(): NgbModalRef {
    if (this.alertModalRef !== null) {
      this.alertModalRef.close();
      this.alertModalRef = null;
    }
    this.alertModalRef = this.modalService.open(AlertModalComponent, {
      windowClass: 'general-modal',
    });
    this.alertModalRef.componentInstance.title = 'Warning';
    this.alertModalRef.componentInstance.text =
      'You either clicked buttons too fast or played multiple games at the same time. Stop doing that unless you want to see this warning again.';
    this.alertModalRef.componentInstance.ok = 'Understood!';
    this.alertModalRef.componentInstance.hero = null;
    this.alertModalRef.componentInstance._service = this;
    return this.alertModalRef;
  }

  public openFairness(): NgbModalRef {
    this.fairnessModalRef = this.modalService.open(FairnessModalComponent, {
      windowClass: 'general-modal',
    });
    this.fairnessModalRef.componentInstance._service = this;
    return this.fairnessModalRef;
  }

  public openFairnessResult(data: any): NgbModalRef {
    this.fairnessResultModalRef = this.modalService.open(FairnessResultModalComponent, {
      windowClass: 'general-modal',
    });
    this.fairnessResultModalRef.componentInstance.data = data;
    return this.fairnessResultModalRef;
  }

  public openTermsAndConditions(): NgbModalRef {
    this.termsAndConditionsModalRef = this.modalService.open(TermsandconditionsModalComponent, {
      windowClass: 'general-modal large',
    });
    this.termsAndConditionsModalRef.componentInstance._service = this;
    return this.termsAndConditionsModalRef;
  }
  public openPrivacyPolicy(): NgbModalRef {
    this.privacyPolicyModalRef = this.modalService.open(PrivacypolicyModalComponent, {
      windowClass: 'general-modal large',
    });
    this.privacyPolicyModalRef.componentInstance._service = this;
    return this.privacyPolicyModalRef;
  }

  public openChestForDeposit(): NgbModalRef {
    this.chestForDepositModalRef = this.modalService.open(ModalChestForDepositComponent, {
      windowClass: 'general-modal',
    });
    this.chestForDepositModalRef.componentInstance._service = this;
    return this.chestForDepositModalRef;
  }

  public openActiveBonuses(data: { available: number } = { available: 0 }): NgbModalRef {
    this.activeBonusesModalRef = this.modalService.open(ModalActiveBonusesComponent, {
      windowClass: 'general-modal',
    });
    this.activeBonusesModalRef.componentInstance._service = this;
    this.activeBonusesModalRef.componentInstance.data = data;
    return this.activeBonusesModalRef;
  }

  public openDepositPromotion(items: Array<any>): NgbModalRef {
    this.depositPromotionModalRef = this.modalService.open(DepositPromotionModalComponent, {
      windowClass: 'general-modal',
    });
    this.depositPromotionModalRef.componentInstance._service = this;
    this.depositPromotionModalRef.componentInstance._items = items;
    return this.depositPromotionModalRef;
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/shared/modal.service.ts